import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  stats: {},
  stat: null,
  graphStats: {},
  topSellingStats: {},
  expenseStats: {},
  salesByOrderType: {}
};

const slice = createSlice({
  name: "stat",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CATEGORIES
    getStatsSuccess(state, action) {
      state.isLoading = false;
      state.stats = action.payload;
    },

    getStatsOrderTypeSuccess(state, action) {
      state.isLoading = false;
      state.salesByOrderType = action.payload;
    },

    // GET STAT
    getStatSuccess(state, action) {
      state.isLoading = false;
      state.stat = action.payload;
    },

    // GET Graph STATS
    getGraphStatsSuccess(state, action) {
      state.isLoading = false;
      state.graphStats = action.payload;
    },

    //Get Top Selling Stats
    getTopSellingStatsSuccess(state, action) {
      state.isLoading = false;
      state.topSellingStats = action.payload;
    },

    // Get Expense Stats
    getExpenseStatsSuccess(state, action) {
      state.isLoading = false;
      state.expenseStats = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getStatsForTopSelling(venueId, startDate, endDate) {

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/stats/getStatsTopItemsForGraph?venueId=${venueId}&startDate=${startDate}&endDate=${endDate}`
      );
      dispatch(slice.actions.getTopSellingStatsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function getStatsForExpenses(venueId, startDate, endDate) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/stats/getStatsForExpenses?venueId=${venueId}&startDate=${startDate}&endDate=${endDate}&isDeleted=false&limit=250`
      );
      dispatch(slice.actions.getExpenseStatsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getStats(venueId, startDate, endDate) {
 
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/stats?venueId=${venueId}&startDate=${startDate}&endDate=${endDate}`
      );
      dispatch(slice.actions.getStatsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getStatsForGraph(venueId, startDate, endDate) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/stats/getStatsForGraph?venueId=${venueId}&startDate=${startDate}&endDate=${endDate}`
      );
      dispatch(slice.actions.getGraphStatsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getStat(categoryId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/stats/${categoryId}`
      );
      dispatch(slice.actions.getStatSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getStatsSalesByOrderType(venueId, startDate, endDate) {

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/stats/getStatsForOrderType?venueId=${venueId}&startDate=${startDate}&endDate=${endDate}`
      );
      dispatch(slice.actions.getStatsOrderTypeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
